/* eslint-disable */
import React,{Component} from 'react';
import PropTypes from 'prop-types';
//utils
import {safeGet, getOrdinalSuffix} from '../../../../../utils';
//children
import SimpleDropdown from '../../../../common/SimpleDropdown';
import Banner from '../../../../common/Banner';
import Radiobutton from '../../../../common/Radio/radioButton';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../../../common/Modal';
import AccountSection from '../AccountSection';
import {Translations,
  convertStringToArray,
  convertStringToArrayForOption} from '../../../../../utils';

//style
import './OrderableSweepList.css';

export default class OrderableSweepList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderOfExecution: [],
      showDynamicSweepWarning: false,
      showIntraOrderEditModal: false
    };
  }

  componentWillMount() {
    var orderOfExecution = [...this.props.orderOfExecution];
    var isSweepOrderDefined = this.props.isSweepOrderDefined
   this.setState({orderOfExecution, "isSweepOrderDefined": isSweepOrderDefined});
  }

  componentDidMount() {
    // setting default order back to parent state
    this.props.setSweepsAndSweepGroupsOrder(this.state.orderOfExecution);
  }

  componentWillReceiveProps(nextProps) {
    var orderOfExecution = [...nextProps.orderOfExecution];
    this.setState({orderOfExecution});

  }

  translations = (word) => {
  return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  onOrderChanged = (index, sweep, sweepGroup, event) => {
    var orderOfExecution = [...this.state.orderOfExecution];
    if(sweep) {
      orderOfExecution[index] = {
        orderNumber: event.target.value,
        sweepId: sweep.id
      }
    }else if(sweepGroup) {
      orderOfExecution[index] = {
        orderNumber: event.target.value,
        sweepGroupId: sweepGroup.id,
        intraGroupOrder:  orderOfExecution[index].intraGroupOrder
      }
    }
    this.props.setSweepsAndSweepGroupsOrder(orderOfExecution);
    this.setState({orderOfExecution});

  }

  handleSweepParticipantsRadioChange = (value, name) => {
  this.setState({
      isSweepOrderDefined: value
  });
  this.props.isSweepOrderRequired(value);

}

  setDefaultOrderingOfInstructionsIfNoOrder = (_ooeOfGroup, sweepGroup) => {
    var _intraOrder;
    if(_ooeOfGroup.intraGroupOrder) {
      sweepGroup.sweepInstructions.forEach(si => {
        _intraOrder = _ooeOfGroup.intraGroupOrder.find(ooe => ooe.sweepInstructionId === si);
        if(_intraOrder === undefined || _intraOrder.orderNumber === undefined) {
          _ooeOfGroup.intraGroupOrder.push({
            sweepInstructionId: si,
            orderNumber: '1'
          });
        }
      });
    }else {
      _ooeOfGroup.intraGroupOrder = [];
      sweepGroup.sweepInstructions.forEach(si => {
        _ooeOfGroup.intraGroupOrder.push({
          sweepInstructionId: si,
          orderNumber: '1'
        });
      });
    }

    return _ooeOfGroup.intraGroupOrder;

  }

  onIntraOrderEditBtnClick = (currentSelectedGroupIndex, currentSelectedGroup) => {
    var _ooeOfGroup = this.state.orderOfExecution.find(ooe => ooe.sweepGroupId === currentSelectedGroup.id);
    let currentSelectedGroupIntraOrder = [];
    currentSelectedGroupIntraOrder = this.setDefaultOrderingOfInstructionsIfNoOrder(_ooeOfGroup, currentSelectedGroup);
    this.setState({
      currentSelectedGroupIndex,
      currentSelectedGroup,
      currentSelectedGroupIntraOrder,
      showIntraOrderEditModal: true
    });
  }

  getOrderingOptions = (sweepInstructionList) => {
    var optionsLength = sweepInstructionList.length + this.props.sweepGroups.length;
    var orderingOptions = [];
    for(var i=1; i<=optionsLength; i++) {
      orderingOptions.push({
        id: `${i}`,
        value: getOrdinalSuffix(i)
      });
    }

    return orderingOptions;
  }

  shouldDisable = (item) => {
    var disable = false;
    if(this.props.shouldDisable) {
      disable = this.props.shouldDisable(item, this.props.sweepGroups);
    }
    return disable;
  }

  // item.sweepInstructions.map((si, index) => (<label>{`${index+1}. ${si}`}</label>))
  renderFirstHalfList = (item) => {
    if (item.sweepInstructions !== undefined) {
      const sweepInstructionsSet1 = item.sweepInstructions.slice(null, Math.ceil(item.sweepInstructions.length / 2));
      let orderOfExecution = [...this.state.orderOfExecution];
      let sweepInstructionsItem = [];
      sweepInstructionsSet1.forEach(sele => {
        this.props.sweepInstructions.forEach(iele => {
          if (sele === iele.id) {
            sweepInstructionsItem.push(iele)
          }
        });
      });
      let sweepGroup = orderOfExecution.filter(x => x.sweepGroupId === item.id && x.intraGroupOrder !== undefined)
      let instructionSet = [];
      if (sweepGroup.length > 0) {
        sweepInstructionsItem.forEach(ins => {
          sweepGroup[0].intraGroupOrder.forEach(grp => {
            if (ins.id === grp.sweepInstructionId) {
              instructionSet.push({
                orderNumber: grp.orderNumber,
                ...ins
              });
            }
          });
        });

      }
      return instructionSet
        .filter(si => sweepInstructionsSet1.indexOf(si.id) !== -1)
        .map((si, index) => (<label key={si.id}>{`${si.orderNumber}. ${si.sweepId}`}</label>));
    }
  }

  renderSecondHalfList = (item) => {
    if (item.sweepInstructions !== undefined) {
      const sweepInstructionsSet2 = item.sweepInstructions.slice(Math.ceil(item.sweepInstructions.length / 2));
      let orderOfExecution = [...this.state.orderOfExecution];
      let sweepInstructionsItem = [];
      sweepInstructionsSet2.forEach(sele => {
        this.props.sweepInstructions.forEach(iele => {
          if (sele === iele.id) {
            sweepInstructionsItem.push(iele)
          }
        });
      });
      let sweepGroup = orderOfExecution.filter(x => x.sweepGroupId === item.id && x.intraGroupOrder !== undefined)
      let instructionSet = [];
      if (sweepGroup.length > 0) {
        sweepInstructionsItem.forEach(ins => {
          if (sweepGroup[0].intraGroupOrder !== undefined) {
            sweepGroup[0].intraGroupOrder.forEach(grp => {
              if (ins.id === grp.sweepInstructionId) {
                instructionSet.push({
                  orderNumber: grp.orderNumber,
                  ...ins
                });
              }
            });
          }
      });
    }

      return instructionSet
        .filter(si => sweepInstructionsSet2.indexOf(si.id) !== -1)
        .map((si, index) => (<label key={si.id}>{`${si.orderNumber}. ${si.sweepId}`}</label>));
    }
  }

  getIntraOrderOfExecution = (intraOrderOfExecution) => {
    var orderOfExecution = [...this.state.orderOfExecution];
    var index = orderOfExecution.findIndex(ooe => ooe.sweepGroupId === this.state.currentSelectedGroup.id);
    orderOfExecution[index] = {...orderOfExecution[index], intraGroupOrder: intraOrderOfExecution};
    this.setState({orderOfExecution});
    this.props.setSweepsAndSweepGroupsOrder(orderOfExecution);
  }

  toggleDialog = () => {

    this.setState({showIntraOrderEditModal: false});
  }

  render() {
    var sweepInstructionList =[];
    var sweepGPList =[];
    var uniqueSweepGp =[];
    let divJSX = ''
    if(this.props.pageJSON !== undefined && this.props.pageJSON.staticText_orderOfSweepExecution !== undefined) {
      divJSX = (
        <div className="form-row">
        <div className="form-column">
        {this.translations(this.props.pageJSON.staticText_orderOfSweepExecution.sweepOrder)}
        </div>
        <div className="form-column">
        <label className="radio-label">
        {this.translateWord(this.props.pageJSON.staticText_orderOfSweepExecution.options)[0].split('=')[1]}
        <Radiobutton
        setInputvalue={this.handleSweepParticipantsRadioChange}
        name="isSweepOrderDefined"
        disabled = {this.props.disabled}
        _value={this.state.isSweepOrderDefined}
        value="true"
        />
        </label>
        <label className="radio-label" style={{marginLeft: '20px'}}>
          {this.translateWord(this.props.pageJSON.staticText_orderOfSweepExecution.options)[1].split('=')[1]}
        <Radiobutton
        setInputvalue={this.handleSweepParticipantsRadioChange}
        name="isSweepOrderDefined"
        disabled = {this.props.disabled}
        _value={this.state.isSweepOrderDefined}
        value="false"
        />
        </label>
        </div>
        </div>
      )
    }
    this.props.sweepGroups.length > 0 ? this.props.sweepGroups.filter(si => sweepGPList.push(...si.sweepInstructions)) : [];
    this.props.sweepInstructions.filter((item, index) => {
    if(this.props.sweepGroups.length > 0 && sweepGPList.length > 0){
      for(var value of sweepGPList){
            if(uniqueSweepGp.indexOf(value) === -1){
                uniqueSweepGp.push(value);
            }
        }
          if(uniqueSweepGp.indexOf(item.id) === -1){
            sweepInstructionList.push(item)
              }
            }
    else{
              sweepInstructionList.push(item)
        }
      })

      var orderingOptions = this.getOrderingOptions(sweepInstructionList);
      //var myValue = { id: 'Defined in Group', value: 'Defined in Group'}
      var newValue = [...orderingOptions]

    return (
      <div className="orderable-sweep-list-wrapper">
      {
        this.props.showWarning ? (
          <Banner bannerType="warning">{this.props.bannerText}</Banner>
        ) : ''
      }
      {divJSX}
      {   this.state.isSweepOrderDefined !== undefined &&
          this.state.isSweepOrderDefined && sweepInstructionList.map((item, index) => (
          <div className="orderable-sweep-list orderable-sweep-list--sweep" key={item.id || index}>
          <div className="orderable-sweep-list--sweep__ordering-dropdown">
          <SimpleDropdown options={newValue || []}
          value={this.state.orderOfExecution[index].orderNumber}
          _onChange={this.onOrderChanged.bind(this, index, item, null)}
          width="135px"
          showPleaseSelectOption={false}
          disabled={this.shouldDisable(item) || this.props.disabled} />
          </div>
          <div className="orderable-sweep-list--sweep__sweep-details">
          <label className="orderable-sweep-list--sweep__sweep-details__sweep-name">
          {`${item.sweepId} ${safeGet(item, "sweepParticipantsAccounts.currency.name", undefined) ? '(' :''}${safeGet(item, "sweepParticipantsAccounts.currency.name")}${safeGet(item, "sweepParticipantsAccounts.currency.name", undefined) ? ')' :''}`}

          </label>
          <p className="orderable-sweep-list--sweep__sweep-details__sweep-type">
          {`${item.sweepType ? item.sweepType + ',' : '' } ${safeGet(item, "sweepParticipantsAccounts.sweepType.name")}`}
          </p>
          </div>
          <AccountSection type="master" sweepInstruction={item} accounts={this.props.accounts} bsClass="orderable-sweep-account-list" />
          <AccountSection type="sub" sweepInstruction={item} accounts={this.props.accounts} bsClass="orderable-sweep-account-list" />
          </div>
        ))
      }
      {  this.state.isSweepOrderDefined !== undefined &&
         this.state.isSweepOrderDefined && this.props.sweepGroups.map((item, index) => (
          <div className="orderable-sweep-list orderable-sweep-list--sweep-group" key={item.id || index}>
          <div className="orderable-sweep-list--sweep-group__ordering-dropdown">
          <SimpleDropdown options={orderingOptions || []}
          value={this.state.orderOfExecution[sweepInstructionList.length + index] ? this.state.orderOfExecution[sweepInstructionList.length + index].orderNumber : ''}
          _onChange={this.onOrderChanged.bind(this, sweepInstructionList.length + index, null, item)}
          width="135px"
          showPleaseSelectOption={false}
          disabled={this.shouldDisable(item) || this.props.disabled} />
          </div>
          <div className="orderable-sweep-list--sweep-group__sweep-details">
          <label className="orderable-sweep-list--sweep-group__sweep-details__sweep-name">
          {`${'Group'} ${item.sweepGroupId}-${item.sweepGroupId ===9 ? '00':'00'}${index +1}`}
          </label>
          <p className="orderable-sweep-list--sweep-group__sweep-details__sweep-type">
          {`${item.sweepType ? item.sweepType + ',' : '' } ${safeGet(item, "sweepParticipantsAccounts.sweepType.name")}`}
          </p>
          </div>
          <div className="orderable-sweep-list--sweep-group__sweep-instructions">
          <div className="orderable-sweep-list--sweep-group__sweep-instructions__list orderable-sweep-list--sweep-group__sweep-instructions__list--left">
          {this.renderFirstHalfList(item)}
          </div>
          <div className="orderable-sweep-list--sweep-group__sweep-instructions__list orderable-sweep-list--sweep-group__sweep-instructions__list--right">
          {this.renderSecondHalfList(item)}
          </div>
          <IntraOrderEditBtn _onClick={this.onIntraOrderEditBtnClick}
          index={index}
          disabled={this.props.disabled}
          item={item}
          btnTxt="Edit intra-group order" />
          </div>
          </div>
        ))
      }
      <IntraOrderEditModal modalTitle="Edit intra-group execution order"
      showDialog={this.state.showIntraOrderEditModal}
      toggleDialog={this.toggleDialog}
      masterSweepInstructions={this.props.sweepInstructions}
      sweepGroup={this.state.currentSelectedGroup}
      sweepGroupIndex={this.state.currentSelectedGroupIndex}
      _currentSelectedGroupIntraOrder={this.state.currentSelectedGroupIntraOrder}
      setIntraOrderOfExecution={this.getIntraOrderOfExecution}
      cancelBtnTxt="Cancel"
      applyBtnTxt="Apply"
      bsClass="gdocs-gls-cashcon-sweep-group-intra-order-edit-modal" />
      </div>
    )
  }
}

OrderableSweepList.defaultProps = {
  showWarning: false
}

OrderableSweepList.propTypes = {
  sweepInstructions: PropTypes.array.isRequired,
  sweepGroups: PropTypes.array.isRequired,
  accounts: PropTypes.array.isRequired,
  orderOfExecution: PropTypes.array.isRequired,
  setSweepsAndSweepGroupsOrder: PropTypes.func.isRequired,
  shouldDisable: PropTypes.func,
  showWarning: PropTypes.bool,
  editOrderBtnText: PropTypes.string.isRequired,
  bannerText: PropTypes.string.isRequired
}


class IntraOrderEditBtn extends React.Component {
  handleClick = () => {
    this.props._onClick(this.props.index, {...this.props.item});
  }

  render() {
    return (
      <button className={"gdocs-btn-default " + this.props._className}
      disabled={this.props.disabled || this.props.item.sweepInstructions === undefined || this.props.item.sweepInstructions.length === 0}
      onClick={this.handleClick}>
      {this.props.btnTxt}
      </button>
    );
  }
}

class IntraOrderEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intraOrderOfExecution: []
    };
}

  componentDidMount() {
    this.setState({
      intraOrderOfExecution: this.props._currentSelectedGroupIntraOrder
    });
  }

  componentWillReceiveProps(nextProps) {
      this.setState({
        intraOrderOfExecution: nextProps._currentSelectedGroupIntraOrder
      });
  }

  getOrderingOptions = () => {
    var optionsLength = this.props.sweepGroup.sweepInstructions ? this.props.sweepGroup.sweepInstructions.length : 0;
    var orderingOptions = [];
    for(var i=1; i<=optionsLength; i++) {
      orderingOptions.push({
        id: i,
        value: getOrdinalSuffix(i)
      });
    }
    return orderingOptions;
  }

  onOrderChanged = (sweepId, event) => {
    let intraOrderOfExecution = [...this.state.intraOrderOfExecution];
    let intraOrderOfExecutionIndex = intraOrderOfExecution.findIndex(ioe => ioe.sweepInstructionId === sweepId);
    intraOrderOfExecution[intraOrderOfExecutionIndex] = {
      ...intraOrderOfExecution[intraOrderOfExecutionIndex],
      orderNumber:event.target.value
    };
    this.setState({intraOrderOfExecution})
  }


  onApply = () => {
        this.props.setIntraOrderOfExecution(this.state.intraOrderOfExecution);
        this.props.toggleDialog();
     }

  getIntraOrderNumber = (si) => {
    if(this.state.intraOrderOfExecution !== undefined){
        return this.state.intraOrderOfExecution.find(ioe => ioe.sweepInstructionId === si).orderNumber;
    }

  }

  render() {
    var orderingOptions = [],
    set1 = [],
    set2= [];
    if(this.props.sweepGroup && this.props.sweepGroup.sweepInstructions) {
      var {sweepInstructions} = this.props.sweepGroup;
      orderingOptions = this.getOrderingOptions();
      set1 = sweepInstructions.slice(null, Math.ceil(sweepInstructions.length/2));
      set1 = this.props.masterSweepInstructions.filter(msi => set1.indexOf(msi.id) !== -1);

      set2 = sweepInstructions.slice(Math.ceil(sweepInstructions.length/2));
      set2 = this.props.masterSweepInstructions.filter(msi => set2.indexOf(msi.id) !== -1);
    }
    return (
      <Modal show={this.props.showDialog} onClose={this.props.toggleDialog} bsClass={this.props.bsClass}>
      <ModalHeader title={this.props.modalTitle} />
      <ModalBody>
      {
        this.props.sweepGroup && this.props.sweepGroup.sweepInstructions ? (
          <div className="intra-group-ordering-container clearfix">
          <div className="intra-group-heading clearfix">{`${'Group'} ${this.props.sweepGroup.sweepGroupId}-${this.props.sweepGroupIndex+1 === 9 ? '00':'0'}${this.props.sweepGroupIndex +1}`}</div>
          <div className="intra-group-ordering-container__list intra-group-ordering-container__list--left">
          {
            set1.map(si => (
              <div className="intra-group-ordering-container__list-group" key={si.id}>
              <div className="intra-group-ordering-container__list__label">
              <label>{si.sweepId}</label>
              </div>
              <div className="intra-group-ordering-container__list__dropdown">
              <SimpleDropdown options={orderingOptions || []}
              _onChange={this.onOrderChanged.bind(this, si.id)}
              value={this.getIntraOrderNumber(si.id)}
              showPleaseSelectOption={false}
              width="98px" />
              </div>
              </div>
            ))
          }
          </div>
          <div className="intra-group-ordering-container__list intra-group-ordering-container__list--right">
          {
            set2.map(si => (
              <div className="intra-group-ordering-container__list-group" key={si.id}>
              <div className="intra-group-ordering-container__list__label">
              <label>{si.sweepId}</label>
              </div>
              <div className="intra-group-ordering-container__list__dropdown">
              <SimpleDropdown options={orderingOptions || []}
              _onChange={this.onOrderChanged.bind(this, si.id)}
              value={this.getIntraOrderNumber(si.id)}
              showPleaseSelectOption={false}
              width="98px" />
              </div>
              </div>
            ))
          }
          </div>
          </div>
        ) : 'No Sweep Instructions in this group'
      }
      </ModalBody>
      <ModalFooter>
      <button className="gdocs-btn-default cancel-btn" onClick={this.props.toggleDialog}>
      {this.props.cancelBtnTxt}
      </button>
      <button className="gdocs-btn-primary apply-btn" onClick={this.onApply} disabled={false}>
      {this.props.applyBtnTxt}
      </button>
      </ModalFooter>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/OrderableSweepList/OrderableSweepList.js